module.exports = __webpack_public_path__ + "static/media/no-favorites.bd781bb8.png";